import { useEffect } from "react";
import { A3MetadataCard } from "./card";
import { A3MetadataNew } from "./new";
import { Route, Routes } from "react-router-dom";
import { setDocumentTitle } from "@/lib/documentTitle";

import { A3MetadataTable } from "./table";

export default function A3Metadata() {
  useEffect(() => {
    setDocumentTitle("Quantilia | Métadonnées A3");
  }, []);

  return (
    <Routes>
      <Route index element={<A3MetadataTable />} />
      <Route path="/new" element={<A3MetadataNew />} />
      <Route path=":id" element={<A3MetadataCard />} />
    </Routes>
  );
}
